import styled from 'styled-components';
import { AppBar } from '@material-ui/core';

const TopBarStyled = styled(AppBar)`
  background-size: 100% 100%;
  z-index: ${(props) => props.theme.zIndex.drawer + 1};
  .datalake {
    height: 48px;
    width: 200px;
  }
  .datalake-test {
    height: 48px;
    width: 344px;
  }
  .toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 56px;
    .top-logo-left {
      /* border: 1px solid red; */
      display: flex;
      align-items: center;
      span.icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: ${(props) => props.theme.spacing(2)};
        font-size: 18px;
        color: #fff;
      }
      .dataLake {
        display: flex;
        flex-direction: column;
      }
    }
    .menuButton {
      display: none;
    }

    @media screen and (max-width: 1440px) {
      .menuButton {
        display: block;
      }
      .top-logo-left {
        display: none;
      }
      .title {
        display: none;
      }
    }
  }

  .menuButton {
    margin-right: ${(props) => props.theme.spacing(2)};
    padding: 0;
    .menu-icon {
      color: ${(props) => props.theme.palette.secondary.contrastText};
      font-size: 28px;
    }
  }

  .logo {
    font-size: 28px;
    font-weight: 700;
    color: ${(props) => props.theme.palette.secondary.contrastText};
  }

  .account {
    margin: ${(props) => props.theme.spacing(1)};
    .avatar {
      height: 32px;
      width: 32px;
      background-color: ${(props) => props.theme.palette.primary.contrastText};
    }

    .popover {
      width: 200px;
    }
  }

  .notifications {
    margin: ${(props) => props.theme.spacing(1)};
    padding: 0;
    icon: {
      background-color: ${(props) => props.theme.palette.secondary.main};
      color: ${(props) => props.theme.palette.secondary.contrastText};
    }

    .popover {
      width: 320px;
    }

    .notificationIcon {
      font-size: 32px;
    }
  }

  .exit {
    margin-right: 16px;
    display: flex;
    align-items: center;
    position: relative;
    .sc-gtsrHT {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      .icon {
        width: 36px;
        height: 36px;
        fill: white;
      }
    }
    /* margin-right: ${(props) => props.theme.spacing(4)}; */
    padding: 0;

    /* .exitIcon {
      font-size: 48px;
      color: ${(props) => props.theme.palette.secondary.contrastText};
    } */
  }
`;

export { TopBarStyled };
